import * as React from "react";
import { RadioBoxFieldSchema } from "@generation/core";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { ItemValue } from "../Components/ItemValue";

import "./ReadItem.scss";
import { useDataContext, getValueFromObject } from "@generation/overview-core";

interface IRadioFieldProps {
  field: RadioBoxFieldSchema;
  name: string;
}

export const RadioField = withHideOnFieldHoc(
  withRenderFieldHoc((props: IRadioFieldProps): JSX.Element => {
    let value: string | null = getValueFromObject(useDataContext(), props.name);

    const optionWithValue = props.field.options?.find((option) => option.value === value);

    if (optionWithValue) {
      value = optionWithValue.label;
    }

    const { overview } = props.field;
    value = overview?.formatValue?.(value) ?? value;
    const renderValue = overview?.render?.(value) ?? value;

    return <ItemValue value={renderValue} />;
  })
);
